import { Box } from "../../../../../../mads";
import { Text } from "../../../../../../mads/Text";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";

import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    alignItems: "flex-start",
    gap: 1,
  },
  regular: {
    color: colors.neutral[1000],
  },
  simple: {
    color: colors.neutral[800],
  },
});

export function JobLocation() {
  const viewjobOneGraphModel = useViewjobOneGraphModel();
  const { isCondensedRating, isSimpleVjImproveActive } = viewjobOneGraphModel?.features ?? {};
  const formattedLocation = viewjobOneGraphModel?.job?.location?.formattedStreetAddress;

  const textStyle = isSimpleVjImproveActive && !isCondensedRating ? styles.simple : styles.regular;

  if (!formattedLocation) {
    return null;
  }

  return (
    <Box sx={styles.container}>
      <Text level={3} sx={textStyle}>
        {formattedLocation}
      </Text>
    </Box>
  );
}
